import helper from 'helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('mediaGallery');
export const actions = helper.createActions('mediaGallery', actionTypes);